interface MissionDraft {
  aircraftId: string;
  baseId: string;
  legs: readonly { originCode: string; originName: string }[];
}
interface MissionReferences {
  bases: readonly { id: string; name: string; airportCode: string | null }[];
  aircraft: readonly { id: string; baseIds?: readonly string[] }[];
}

/** Hydrate empty departure fields after saved drafts and reference data meet. */
export function restoreMissionOrigin<T extends MissionDraft>(
  draft: T,
  references: MissionReferences,
): T {
  const aircraft = references.aircraft.find((item) => item.id === draft.aircraftId);
  if (!aircraft) return draft;
  const bases = references.bases.filter((base) => aircraft.baseIds?.includes(base.id));
  const base =
    bases.find((item) => item.id === draft.baseId) || (bases.length === 1 ? bases[0] : undefined);
  if (!base) return draft;
  return {
    ...draft,
    baseId: base.id,
    legs: draft.legs.map((leg, index) =>
      index === 0
        ? {
            ...leg,
            originCode: leg.originCode || base.airportCode || '',
            originName: leg.originName || base.name,
          }
        : leg,
    ),
  };
}
